export default function DataSecurity() {
    return (
        <section>
            <h2 id="data-security" data-testid="data-security">
                V. COMO MANTEMOS OS DADOS SEGUROS
            </h2>
            <p>
                A AMBEV armazenará as informações coletadas em seu App em
                servidores próprios ou por ela contratados. Ainda, todas as
                informações coletadas serão criptografadas e anonimizadas, de
                modo a garantir a segurança das informações e a dissociação de
                dados pessoais eventualmente coletados.
            </p>
            <p>
                A AMBEV utiliza os meios razoáveis de mercado e legalmente
                requeridos para preservar a privacidade dos dados coletados em
                seu App. Desta forma, adota as seguintes precauções, em
                observância às diretrizes sobre padrões de segurança
                estabelecidas no Decreto nº 8.771/2016, tais como:
            </p>
            <ol type="i">
                <li>
                    A AMBEV utiliza os métodos padrão e de mercado para
                    criptografar e anonimizar os dados coletados;
                </li>
                <li>
                    A AMBEV possui proteção contra acesso não autorizado a seus
                    sistemas;
                </li>
                <li>
                    A AMBEV somente autoriza o acesso de pessoas previamente
                    estabelecidas ao local onde são armazenadas as informações
                    coletadas;
                </li>
                <li>
                    Aqueles que entrarem em contato com as informações deverão
                    se comprometer a manter sigilo absoluto. A quebra do sigilo
                    acarretará responsabilidade civil e o responsável será
                    responsabilizado nos moldes da legislação brasileira; e
                </li>
                <li>
                    Manutenção do inventário indicando momento, duração,
                    identidade do funcionário, ou do responsável pelo acesso e o
                    arquivo objeto, com base nos registros de conexão e de
                    acesso a aplicações, conforme determinado no artigo 13 do
                    Decreto nº 8.771/2016.
                </li>
            </ol>
            <p>
                A AMBEV adota os melhores esforços, no sentido de preservar a
                privacidade dos dados dos Usuários. Entretanto, nenhum App é
                totalmente seguro e a AMBEV não pode garantir integralmente que
                todas as informações que trafegam no App não sejam alvo de
                acessos não autorizados perpetrados por meio de métodos
                desenvolvidos para obter informações de forma indevida. Por esse
                motivo, nós incentivamos os Usuários a tomar as medidas
                apropriadas para se proteger, como, por exemplo, mantendo
                confidenciais todos os nomes de usuário e senhas.
            </p>
            <p>
                Também aproveitamos para informar que a AMBEV não tem nenhuma
                ingerência ou responsabilidade em relação a plataformas de
                terceiros, ainda que sejam parceiros comerciais.
            </p>
        </section>
    );
}
